<template>
  <div>
    <el-popover placement="bottom-start" width="420" popper-class="popper-tree declare-dep" @hide="handledHide" trigger="click">
      <el-tree
        :props="defaultProps"
        :data="treeData"
        show-checkbox
        node-key="id"
        ref="tree"
        highlight-current
        check-strictly
        :default-expanded-keys="expandedData"
        :filter-node-method="filterDeptNode"
        @check-change="handleCheckChange"
      >
        <span :class="['custom-tree-node', isDisableDeleted && data.isDeleted ? 'delete' : '']" slot-scope="{ node, data }">
          {{ node.label }}
        </span>
      </el-tree>
      <el-input slot="reference" v-model="department" placeholder="请选择部门名称" clearable></el-input>
    </el-popover>
  </div>
</template>
<script>
export default {
  props: {
    value: String,
    isDisableDeleted: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      expandedData: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      depList: [],
      department: '',
      departmentNo: '',
    }
  },
  watch: {
    department: {
      handler(val) {
        this.$refs.tree && this.$refs.tree.filter(val);
        if (!val) {
          this.departmentNo = "";
          if (this.$refs.tree) {
            setTimeout(() => {
              const depTree = _.cloneDeep(this.copyTreeData);
              this.treeData = depTree;
            }, 10)
            this.$refs.tree.setCheckedKeys([]);
          }
        }
        this.$emit('input', this.departmentNo);
      },
    },
  },
  mounted () {
    this.getDep();
  },
  methods: {
    async getDep() {
      await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then((res) => {
        this.depList = res.data || [];
        const obj = {};
        let defaultCheckedDeptId = null;
        let defaultCheckedDeptName = null;
        this.depList.forEach((v) => {
          if (this.value && v.code === this.value) {
            defaultCheckedDeptId = v.id;
            this.departmentNo = v.code;
            this.department = defaultCheckedDeptName = v.displayName;
          }
          const objClone = _.cloneDeep(obj);
          (objClone.id = v.id), (objClone.code = v.code), (objClone.label = v.displayName);
          if (v.parentId === null) {
            this.expandedData.push(v.id);
            objClone.children = this.depList.filter((t) => t.parentId === v.id);
            this.generateMenu(objClone.children);
            this.treeData.push(objClone);
            this.copyTreeData = _.cloneDeep(this.treeData);
          }
        });
        this.$nextTick(() => {
          if (defaultCheckedDeptId) {
            this.$refs.tree.setCheckedKeys([defaultCheckedDeptId]);
            this.$refs.tree && this.$refs.tree.filter(defaultCheckedDeptName);
          }
        })
      });
    },
    generateMenu(chs) {
      chs.forEach((v) => {
        v.label = v.displayName;
        if (this.isDisableDeleted) {
          v.disabled = v.isDeleted;
        }
        v.children = this.depList.filter((t) => t.parentId === v.id);
        this.generateMenu(v.children);
      });
    },
    handleCheckChange(data, checked) {
      if (checked === true) {
        this.checkId = data.id;
        this.departmentNo = data.code;
        this.department = data.label;
        this.$refs.tree.setCheckedKeys([data.id]);
      } else {
        if (this.checkId === data.id) {
          this.checkId = '';
          this.departmentNo = '';
          this.department = '';
          this.$refs.tree.setCheckedKeys([]);
        }
      }
    },
    getChildrenMenu(depData) {
      let depTree = [];
      depData.forEach((t) => {
        if (t.label.indexOf(this.department) != -1) {
          depTree.push(t);
        } else {
          if (t.children && t.children && t.children.length) {
            t.children = this.getChildrenMenu(t.children);
            if (t.children && t.children.length) {
              depTree.push(t);
            }
          }
        }
      });
      return (this.treeData = depTree);
    },
    filterDeptNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    foldHistoryTree() {
      let treeList = this.treeData;
      //关键代码
      for (let i = 0; i < treeList.length; i++) {
        this.$refs.tree.store.nodesMap[treeList[i].id].expanded = false;
      }
    },
    handledHide() {
      this.$nextTick(() => {
        if (!this.$refs.tree.getCheckedKeys().length) {
          this.department = '';
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>
  .el-tree{
    .delete{
      color: #aaa;
    }
  }
</style>
